module.exports = __webpack_public_path__ + "static/media/img-talent-app-interview-reminding@2x.96eeae67.png";